"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.joinRangeFilters = void 0;
const types_1 = require("../types");
const joinFilterQuery_1 = require("./joinFilterQuery");
const joinRangeFilters = (fieldName, rangeFilters, isNumericArrayField = false) => {
    const cleanedRangeFilters = rangeFilters.filter((rangeFilter) => typeof rangeFilter !== 'undefined');
    const hasValidRangeValue = cleanedRangeFilters.some(rangeFilter => rangeFilter.max !== undefined && rangeFilter.max - (rangeFilter.min || 0) > 0);
    return (0, joinFilterQuery_1.joinFilterQuery)(cleanedRangeFilters
        .filter(rangeFilter => rangeFilter.min !== undefined || rangeFilter.max !== undefined)
        .sort(({ min: range1Min = 0 }, { min: range2Min = 0 }) => range1Min - range2Min)
        .reduceRight((allRangeFilters, rangeFilter) => {
        const previousRange = allRangeFilters.at(-1);
        if (allRangeFilters.length &&
            previousRange &&
            (previousRange.min || 0) - (rangeFilter.min || 0) <= 1) {
            return [
                {
                    min: rangeFilter.min || 0,
                    max: previousRange.max ?? previousRange.min,
                },
                ...allRangeFilters.slice(0, allRangeFilters.length - 1),
            ];
        }
        return [{ min: rangeFilter.min || 0, max: rangeFilter.max }, ...allRangeFilters];
    }, [])
        .map((rangeFilter) => {
        const minValue = rangeFilter.min || 0;
        if (!rangeFilter.max || rangeFilter.max - minValue === 0) {
            // Algolia does not accept sending ranges with non ranges in an OR combination
            if (hasValidRangeValue) {
                return `${fieldName}:${minValue} TO ${minValue}`;
            }
            return `${fieldName}${isNumericArrayField ? ':' : '='}${minValue}`;
        }
        return `${fieldName}:${minValue} TO ${rangeFilter.max}`;
    }), types_1.Conjunction.OR);
};
exports.joinRangeFilters = joinRangeFilters;
//# sourceMappingURL=joinRangeFilters.js.map